import Box from "@mui/material/Box";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import type { BooleanSpec } from "../specs.ts";

interface BooleanEditorProps {
  spec: BooleanSpec;
  value: "yes" | "no" | null;
  onChange: (value: "yes" | "no" | null) => void;
}

/** Any / yes / no as one segmented control. */
export default function BooleanEditor({ spec, value, onChange }: BooleanEditorProps) {
  const choices: { value: "any" | "yes" | "no"; label: string }[] = [
    { value: "any", label: "Any" },
    { value: "yes", label: spec.labels?.yes ?? "Yes" },
    ...(spec.yesOnly ? [] : [{ value: "no" as const, label: spec.labels?.no ?? "No" }]),
  ];
  return (
    <Box sx={{ p: 1.5 }}>
      <ToggleButtonGroup
        exclusive
        fullWidth
        size="small"
        value={value ?? "any"}
        onChange={(_, next: "any" | "yes" | "no" | null) => {
          if (next) onChange(next === "any" ? null : next);
        }}
      >
        {choices.map((c) => (
          <ToggleButton key={c.value} value={c.value} sx={{ textTransform: "none", py: 0.5 }}>
            {c.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
}
